/**
 * Pure grading for the admin First Order Value reconciliation panel (card 2844).
 *
 * Lives outside the component so it is testable without a JSX/CSS transform, and because it is
 * pure logic — the panel is the effect boundary, this is not.
 *
 * ⛔ IT DOES NOT RECOMPUTE ANY FIGURE. The server adjudicates agreement; this only CLASSIFIES the
 *   verdict the payload already carries, so the view can tell three look-alike states apart:
 *   an absent key, a check that compared nothing, and a real verdict.
 */

/**
 * 'did-not-run' — key absent (endpoint failed / older API). ⛔ NOT a pass.
 * 'vacuous'     — ran but compared nothing (0 pairs or 0 publishers). ⛔ NOT a pass.
 * 'agrees' / 'disagrees' — a real verdict the server reached.
 */
export const deriveFovVerdict = (firstOrderValue) => {
  if (!firstOrderValue) return { state: 'did-not-run', ran: false, nonVacuous: false };
  const pairCount = firstOrderValue.pairCount ?? 0;
  const publisherCount = firstOrderValue.publisherCount ?? 0;
  const nonVacuous = pairCount > 0 && publisherCount > 0;
  if (!nonVacuous) return { state: 'vacuous', ran: true, nonVacuous: false };
  return {
    state: firstOrderValue.agrees === true ? 'agrees' : 'disagrees',
    ran: true,
    nonVacuous: true
  };
};
